module.exports = "/packs/american-express-0c60768631bdee130d971945165e51b6.png";